export default "__VITE_ASSET__3A5NjPfv__"